import React from 'react';
import { View, Text, TouchableOpacity, ScrollView } from 'react-native';
import Unicon from '@/components/General/Unicon';
import { StyleSheet } from 'react-native-unistyles';
import { useRouter } from 'expo-router';

const Breadcrumbs = ({ breadcrumbs, onNavigate }) => {
  const router = useRouter();

  return (
    <ScrollView horizontal showsHorizontalScrollIndicator={false} style={styles.scroll} keyboardShouldPersistTaps="handled"
>
      <View testID="files-breadcrumbs" style={styles.row}>
        <TouchableOpacity
          testID="breadcrumb-root"
          onPress={() => onNavigate?.(null) || router.push('/files')}
          style={styles.crumbBtn}
        >
          <Unicon name="home" size={20} colorVariant="primary" library="material" />
          <Text style={styles.crumbActive}>Files</Text>
        </TouchableOpacity>
        
        {breadcrumbs.map((crumb, index) => (
          <React.Fragment key={crumb.id}>
            <Unicon name="chevron-right" size={16} colorVariant="textSecondary" library="material" style={styles.separator} />
            <TouchableOpacity
              testID={`breadcrumb-${crumb.id}`}
              onPress={() => onNavigate?.(crumb.id)}
              style={styles.crumbBtn}
            >
              <Text
                style={index === breadcrumbs.length - 1 ? styles.crumbCurrent : styles.crumbActive}
                numberOfLines={1}
              >
                {crumb.name}
              </Text>
            </TouchableOpacity>
          </React.Fragment>
        ))}
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create(({ colors }) => ({
  scroll: {
    paddingVertical: 8,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  crumbBtn: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  crumbActive: {
    color: colors.primary,
    fontSize: 14,
    marginLeft: 4,
  },
  crumbCurrent: {
    color: colors.text,
    fontSize: 14,
    fontWeight: '600',
  },
  separator: {
    marginHorizontal: 8,
  },
}));

export default Breadcrumbs;
